export default __webpack_public_path__ + "static/media/flag-jp.50633570.png";